<h1 mat-dialog-title>
    {{title}}
</h1>
<div mat-dialog-content>
    <p>{{message}}</p>
</div>
<div mat-dialog-actions>
    <button mat-stroked-button color="primary" (click)="onConfirm()">{{continue}}</button>
    <button mat-stroked-button (click)="onExit()">{{exit}}</button>
</div>